import axiosInstance from "components/utils/axiosInstance";
const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

/////////////////////////////BASIC DATA/////////////////////////////////////
// src/services/campaignService.js

export const postCampaign = async (payload) => {
  const res = await fetch(`${process.env.REACT_APP_TRADEPLUS_URL}/Campaign`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await res.json(); // always valid JSON now

  if (!res.ok) {
    throw new Error(data.message || "Failed to post campaign");
  }

  return data; // { success: true, message: "...", campaign: {...} }
};

export const getCampaigns = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Campaign`
  );
  return response.data;
};

export const getCampaignProducts = async (campaignId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Product?campaignId=${campaignId}`
  );
  return response.data;
};

export const getCampaignOrders = async (campaignId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Campaign/Orders?campaignId=${campaignId}`
  );
  return response.data;
};

export const getOrderItems = async (orderId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Orders/GetOrderItems?orderId=${orderId}`
  );
  return response.data;
};

export const getOrderStatusHistory = async (orderId) => {
  const STATUS_URL = `${API_BASE_URL}/Orders/GetOrderStatusHistory?orderId=${orderId}`;
  const response = await axiosInstance.get(STATUS_URL);
  return response.data;
};

////////////////////////////////////////ANALYTICS////////////////////////////////
export const getCampaignSalesPerDay = async (
  campaignId,
  start = "",
  end = ""
) => {
  const response = await axiosInstance.get(`${API_BASE_URL}/CampaignAnalyticsContoller/SalesPerDay`, {
    params: {
      campaignId,
      startDate: start,
      endDate: end,
    },
  });
  return response.data; // Usually return `.data` directly unless you need metadata
};

export const getCampaignTopCustomersBySales = async (campaignId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/CampaignAnalyticsContoller/TopCustomersBySales?campaignId=${campaignId}`
  );
  return response.data;
};

export const getCampaignTopCustomersByOrders = async (campaignId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/CampaignAnalyticsContoller/TopCustomersByOrders?campaignId=${campaignId}`
  );
  return response.data;
};

export const getCampaignInactiveCustomers = async (
  campaignId,
  page = 1,
  limit = 20
) => {
  const response = await axiosInstance.get(`${API_BASE_URL}/CampaignAnalyticsContoller/InactiveCustomers`, {
    params: {
      campaignId,
      page,
      limit,
    },
  });
  return response.data;
};

export const deleteCampaign = async ({ campaignId, reason, token }) => {
  const response = await axiosInstance.delete(
    `${API_BASE_URL}/Campaign/DeleteCampaign/${campaignId}`,
    {
      params: { reason },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getCampaignOutletsPaged = async ({
  campaignId,
  pageNumber = 1,
  pageSize = 20,
  search = "",
}) => {
  const response = await axiosInstance.get(`${API_BASE_URL}/Campaign/OutletsPaged`, {
    params: { campaignId, pageNumber, pageSize, search },
  });
  return response.data;
};

export const updatedCampaignOutlets = async (id, data)=>{
  const response = await axiosInstance.put(`/Campaign/UpdateCampaignOutlet/${id}`, data);
  return response.data;
}

export const getCampaignHeroProducts = async (campaignId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Campaign/CampaignHeroProducts?campaignId=${campaignId}`
  );
  return response.data;
}

export const bulkAssignCampaignOutlets = async (payload) => {
  const { data } = await axiosInstance.post(
    `${API_BASE_URL}/CampaignOutlet/bulk-assign`,
    payload
  );
  return data;
};